import { defineMessages } from './messages'

export const commonMessages = defineMessages(
  {
    language: 'Tungumál',
    loading: 'Hleður…',
    cancel: 'Hætta við',
    close: 'Loka',
    save: 'Vista',
    saving: 'Vistar…',
    back: 'Til baka',
    logout: 'Skrá út',
    retry: 'Reyna aftur',
    unknownError: 'Villa kom upp',
    noData: 'Engin gögn',
    total: 'Samtals',
    year: 'Ár',
    month: 'Mánuður',
    roleUser: 'Notandi',
    noDataOrAccess: 'Engin gögn fundust fyrir þetta fyrirtæki eða ár (eða þú hefur ekki aðgang).',
    invalidServerResponse: 'Ógilt svar frá netþjóni.',
  },
  {
    en: {
      language: 'Language',
      loading: 'Loading…',
      cancel: 'Cancel',
      close: 'Close',
      save: 'Save',
      saving: 'Saving…',
      back: 'Back',
      logout: 'Log out',
      retry: 'Try again',
      unknownError: 'Something went wrong',
      noData: 'No data',
      total: 'Total',
      year: 'Year',
      month: 'Month',
      roleUser: 'User',
      noDataOrAccess: 'No data was found for this company or year (or you do not have access).',
      invalidServerResponse: 'Invalid response from the server.',
    },
    pl: {
      language: 'Język',
      loading: 'Ładowanie…',
      cancel: 'Anuluj',
      close: 'Zamknij',
      save: 'Zapisz',
      saving: 'Zapisywanie…',
      back: 'Wstecz',
      logout: 'Wyloguj się',
      retry: 'Spróbuj ponownie',
      unknownError: 'Wystąpił błąd',
      noData: 'Brak danych',
      total: 'Łącznie',
      year: 'Rok',
      month: 'Miesiąc',
      roleUser: 'Użytkownik',
      noDataOrAccess: 'Nie znaleziono danych dla tej firmy lub tego roku (albo nie masz do nich dostępu).',
      invalidServerResponse: 'Nieprawidłowa odpowiedź serwera.',
    },
  }
)
